"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var VirtualPlanner = function VirtualPlanner(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M48 7.76L17.392 22.397 48 39.033l30.608-16.635L48 7.76zm.863-7.347l43.37 20.742a1 1 0 0 1 .046 1.78L48.955 46.481a2 2 0 0 1-1.91 0L3.721 22.935a1 1 0 0 1 .046-1.78L47.137.413a2 2 0 0 1 1.726 0zM3.48 30.855l43.748 23.98a2 2 0 0 0 1.924 0L92.52 31.027a1 1 0 0 1 1.481.877v5.122a2 2 0 0 1-1.04 1.755L49.154 62.724a2 2 0 0 1-1.925-.004L3.034 38.338A2 2 0 0 1 2 36.587v-4.855a1 1 0 0 1 1.48-.877zm0 16l43.748 23.98a2 2 0 0 0 1.924 0L92.52 47.027a1 1 0 0 1 1.481.877v5.122a2 2 0 0 1-1.04 1.755L49.154 78.724a2 2 0 0 1-1.925-.004L3.034 54.338A2 2 0 0 1 2 52.587v-4.855a1 1 0 0 1 1.48-.877zm0 16l43.748 23.98a2 2 0 0 0 1.924 0L92.52 63.027a1 1 0 0 1 1.481.877v5.122a2 2 0 0 1-1.04 1.755L49.154 94.724a2 2 0 0 1-1.925-.004L3.034 70.338A2 2 0 0 1 2 68.587v-4.855a1 1 0 0 1 1.48-.877z",
    fill: "currentColor"
  })));
};
var _default = exports.default = VirtualPlanner;